import { ParticipantToParticipantInputBaseValueConverter } from 'General/Resources/ValueConverters/ParticipantToParticipantInputBase';
export class ParticipantToParticipantInputValueConverter extends ParticipantToParticipantInputBaseValueConverter {

}